
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Deployment</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/project']" [queryParams]="{id: deployment?.projectId}">{{ deployment?.projectName }}</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/sites']" [queryParams]="{projectId: deployment?.projectId}">Sites</a></li>
        <li class="breadcrumb-item" *ngIf="deployment?.siteId &amp;&amp; deployment?.siteName"><a [routerLink]="['/site']" [queryParams]="{id: deployment?.siteId}">{{ deployment?.siteName }}</a></li>
        <li class="breadcrumb-item active" *ngIf="!deployment?.siteId || !deployment?.siteName">All</li>
        <li class="breadcrumb-item" *ngIf="deployment?.siteId"><a [routerLink]="['/deployments']" [queryParams]="{siteId: deployment?.siteId}">Deployments</a></li>
        <li class="breadcrumb-item" *ngIf="!deployment?.siteId"><a [routerLink]="['/deployments']" [queryParams]="{projectId: deployment?.projectId}">Deployments</a></li>
        <li class="breadcrumb-item active" *ngIf="deployment?.name">{{ deployment?.name }}</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card-item">
        <div class="card-progress-bar float-right">
          <div class="progress">
            <div class="progress-bar" role="progressbar" title="{{ deployment?.deployedPercentageBar?.title }}" [ngClass]="deployment?.deployedPercentageBar?.type" [style.width]="deployment?.deployedPercentageBar?.width + '%'">{{deployment?.deployedPercentageBar?.value + "%"}}</div>
          </div>
        </div>
        <h4>{{ deployment.name }}<span class="badge ml-1" *ngIf="deployment.rejected" [ngClass]="{'badge-warning': true}">Rejected</span></h4>
        <property-container>
          <property-item><a [href]="'/#/workflow/' + deployment.workflowId">Set Up Deployment</a></property-item>
        </property-container>
        <property-container>
          <property-item [showIf]="deployment.deliveryDate">Delivery Date: {{ deployment.deliveryDate | date: 'yyyy-MM-dd' : 'UTC'}}</property-item>
          <property-item [showIf]="deployment.installDate">Install Date: {{ deployment.installDate | date: 'yyyy-MM-dd': 'UTC'}}</property-item>
        </property-container>
        <property-container>
          <property-item>Installed Devices: {{ deployment.deployedItems }}</property-item>
          <property-item>Total Devices: {{ deployment.plannedItems }}</property-item>
        </property-container>
        <property-container class="red">
          <property-item [showIf]="deployment.pastSchedule"><span class="oi oi-clock"></span> {{ deployment.pastScheduleMessage }}</property-item>
        </property-container>
        <div class="clearfix"></div>
        <div class="float-right">
          <button class="btn btn-outline-danger float-right" *ngIf="deployment.deployedItems &lt;= 0 &amp;&amp; deployment.id" type="button" (click)="remove()"><span class="oi oi-trash"></span> Remove</button>
        </div>
        <div class="clearfix">&nbsp;</div>
      </div>
    </div>
  </div>
</div>